var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkCopyIconHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_339",
    "data-name": "Subtraction 339",
    d: "M9551.535,7147.4h-6.8a4.336,4.336,0,0,1-4.331-4.331v-6.8a4.336,4.336,0,0,1,4.331-4.331h.2v-.2a4.336,4.336,0,0,1,4.331-4.331h6.8a4.336,4.336,0,0,1,4.331,4.331v6.8a4.335,4.335,0,0,1-4.331,4.329h-.2v.206A4.336,4.336,0,0,1,9551.535,7147.4Zm-6.8-13.605a2.473,2.473,0,0,0-2.471,2.47v6.8a2.473,2.473,0,0,0,2.471,2.47h6.8a2.473,2.473,0,0,0,2.471-2.47v-6.8a2.473,2.473,0,0,0-2.471-2.47Zm6.8-1.86a4.336,4.336,0,0,1,4.331,4.331v4.74h.2a2.473,2.473,0,0,0,2.471-2.47v-6.8a2.474,2.474,0,0,0-2.471-2.473h-6.8a2.474,2.474,0,0,0-2.471,2.473v.2Z",
    transform: "translate(-9540.4 -7127.401)",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCopyIconHover);
export default __webpack_public_path__ + "static/media/DarkCopyIconHover.4308dcdcd55ca92a45e4d41c9ba26d51.svg";
export { ForwardRef as ReactComponent };